<template>
  <div :class="raisedCardClass">
    <div class="ml-4">
      <h4 class="anchor-team-title pt-2">{{ cardTitle }}</h4>
      <p class="anchor-team-description">{{ cardDescription }}</p>
      <p>
        <span class="anchor-contact-name">{{ name }}</span><br/>
        <span class="anchor-contact-function">{{ contactTitle }}</span>
      </p>
      <p class="pb-2">
        <a v-bind:href="'mailto:' + email">{{ email }}</a><br/>
        <a v-bind:href="'tel:' + phone">{{ phone }}</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AnchorContact',
  props: {
    cardTitle: String,
    cardDescription: String,
    name: String,
    contactTitle: String,
    email: String,
    phone: String,
    raisedCard: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    contact() {
      return this.$store.getters.accountExecutive;
    },
    raisedCardClass() {
      return this.raisedCard ? 'raised rounded' : '';
    },
  },
};
</script>


<style scoped>
.anchor-team-title {
  color: var(--primary-color);
  font-weight: 400;
  font-size: 20px;
  line-height: 22px;
}

.anchor-team-description {
  font-weight: 100;
  color: #929292;
}

.anchor-contact-name {
  font-weight: 550;
}

.anchor-contact-function {
  font-weight: 100;
  color: #929292;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/AnchorContact.vue